import type { JobModuleActionLinkProps } from "./job-module-action-link.type";

import { TAB_KEYS, TAB_PARAM_KEYS } from "@/constants/TabKeys";
import { getModelKey } from "@/modules/model";
import { ModelLink } from "@/modules/model-link";

export const JobModuleActionLink = ({
  subject,
  customContext,
  showIcon = true,
  onClick,
}: JobModuleActionLinkProps) => {
  const modelKey = getModelKey(subject.type);

  if (!modelKey) return null;

  return (
    <ModelLink
      model={modelKey}
      search={`?${TAB_PARAM_KEYS.CONTEXT_TAB_KEY}=${TAB_KEYS.INTERVENTIONS_MODULES}`}
      customContext={customContext}
      item={subject}
      showIcon={showIcon}
      modelAsName
      onClick={onClick}
    />
  );
};
